/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React from "react";

export const validateMinLengthString = (txt, length) => {
  return txt.length >= length;
};

export const identifyMinLengthStringError = (txt, length) => {
  if (txt.length <= length) {
    return "error.input.field.empty";
  } else {
    return "error.input.field.invalid";
  }
};

export const validateMobileNum = num => {
  const mobileNum = num !== null ? num.replace(/\s/g, "") : "";

  return mobileNum.length >= 10;
};

export const identifyMobileNumError = num => {
  const mobileNum = num !== null ? num.replace(/\s/g, "") : "";

  if (mobileNum.length === 0) {
    return "error.input.field.empty";
  } else if (mobileNum.length < 10) {
    return "error.mobile.field.invalid.length";
  } else {
    return "error.input.field.invalid";
  }
};

export const validatePassword = pass => {
  return pass.length >= 8;
};

export const identifyPasswordError = pass => {
  if (pass.length === 0) {
    return "error.input.field.empty";
  } else if (pass.length < 8) {
    return "error.password.field.invalid.length";
  } else {
    return "error.input.field.invalid";
  }
};

export const validateCPassword = (pass, cpass) => {
  return pass === cpass;
};

export const validateEmail = email => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return email.length > 0 && re.test(String(email).toLowerCase());
};

export const identifyEmailError = email => {
  if (email.length === 0) {
    return "error.input.field.empty";
  } else {
    return "error.input.field.invalid";
  }
};



// WEBPACK FOOTER //
// ./src/utils/FieldValidator.js